// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"099287ad","91":"2a3077ba","302":"dda52edb","396":"02b8c9c7","624":"0aa60a46","662":"6ad72899","725":"1a9ee8a0","913":"e38343bb","932":"115c2fe1"}[chunkId] + ".js";
};